<template>
  <f7-page name="hydro-situacia" @page:init="onPageInit">
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <f7-nav-title sliding>Hydrologická situácia</f7-nav-title>
      <f7-nav-right>
        <f7-link icon-ios="f7:arrow_2_circlepath" icon-aurora="f7:arrow_2_circlepath" icon-md="material:autorenew" @click="pageReload($event,false) " href="#" ></f7-link>
        <f7-link icon-ios="f7:arrow_left" icon-aurora="f7:arrow_left" icon-md="material:arrow_back" @click="$f7router.back()" href="#" ></f7-link>
      </f7-nav-right>
    </f7-navbar>
    <template v-if="isDataLoaded">

      <f7-block class="no-margin no-padding">

        <f7-list accordion-list class="no-margin text-forecast-hs">
          <f7-list-item accordion-item v-for="(value, key) in situationData"
                        :key="key"
                        :title="value.region_name"
                        :class="`item-` + value.region">

            <f7-accordion-content>
              <f7-block class="no-padding">

                <template v-if="value.region === 'SK'">

                  <f7-card>
                    <f7-card-content>

                      <div class="margin-bottom-half"><strong class="text-uppercase">SITUÁCIA:</strong>
                        <div class="margin-top-half" v-html="nl2br(value.situacia)"></div>
                      </div>

                      <div class="margin-bottom-half"><strong class="text-uppercase">VÝVOJ:</strong>
                        <div class="margin-top-half" v-html="nl2br(value.vyvoj)"></div>
                      </div>

                      <f7-card class="s-c-wrapper">
                        <f7-card-header class="s-c-header">
                          Predpoveď vodného stavu na zajtra {{ value.predpoved_na | moment('DD.MM.YYYY') }} o 6:00
                        </f7-card-header>
                        <f7-card-content>
                          <f7-list>
                            <f7-list-item v-for="(value_i, key_i) in value.predpoved" :key="key_i"
                                          :title="value_i.station" :after="value_i.value" >
                            </f7-list-item>
                          </f7-list>
                        </f7-card-content>
                        <f7-card-footer>
                          * stanice sú ovplyvnené manipuláciou na VDG
                        </f7-card-footer>
                      </f7-card>

                      <div><small class="text-color-gray">Predpoveď bola aktualizovaná {{ value.created_at | moment('DD.MM.YYYY HH:MM') }}</small></div>


                    </f7-card-content>
                  </f7-card>


                </template>
                <template v-else>

                  <f7-card>
                    <f7-card-content>

                      <div class="margin-bottom-half"><strong class="text-uppercase">HYDROLOGICKÁ SITUÁCIA:</strong>
                        <div class="margin-top-half" v-html="nl2br(value.hodnotenie)"></div>
                      </div>

                      <div class="margin-bottom-half"><strong class="text-uppercase">POČASIE:</strong>
                        <div class="margin-top-half" v-html="nl2br(value.pocasie)"></div>
                      </div>

                      <div class="margin-bottom-half"><strong class="text-uppercase">ZRÁŽKY:</strong>
                        <div class="margin-top-half" v-html="nl2br(value.zrazky)"></div>
                      </div>

                      <div class="margin-bottom-half"><strong class="text-uppercase">HYDROLOGICKÝ VÝVOJ:</strong>
                        <div class="margin-top-half" v-html="nl2br(value.vyvoj)"></div>
                      </div>

                      <div><small class="text-color-gray text-uppercase"> {{ value.created_at | moment('DD.MM.YYYY HH:MM') }} - {{ value.podpis }}</small></div>

                    </f7-card-content>
                  </f7-card>


                </template>


              </f7-block>
            </f7-accordion-content>
          </f7-list-item>
        </f7-list>


      </f7-block>

    </template>
  </f7-page>
</template>
<script>
import Axios from "axios";
import SHMUconf from "../js/SHMUconf";


export default {
  data: function () {
    return {
      situationData: {},
      isDataLoaded: false,
      lastUpdated: 0,
      tCheckInterval: null,
    };
  },
  filters: {
    capitalize: function(s) {
      return s.charAt(0).toUpperCase() + s.slice(1)
    }
  },
  mounted() {
    const self = this;
    // otvorime hlavne menu
    this.$f7.accordion.close('.shmu-i-vodne-zdroje');
    this.$f7.accordion.open('.shmu-i-vodne-zdroje');

  },
  updated() {

    if (this.isDataLoaded) {
      this.$f7.accordion.open('.item-SK');
    }


  },
  destroy() {
    clearInterval(this.tCheckInterval);
  },
  methods: {
    onPageInit() {
      this.pageReload(null, true);
    },
    pageReload(event, isInit) {
      const self = this;

      if (isInit || (this.$moment().unix() - this.lastUpdated) > 60) { // ak posledne stiahnutie bolo menej ako 1 min, tak nedovolime refresh

        self.$f7.dialog.preloader('Načítavam...');

        Axios.get(SHMUconf.API_BASE_URL + 'hydro/getcurrentsituation', {
          crossDomain: true,
          cache: false,
        })
            .then((response) => {
              if (!response.data.error) {
                self.situationData = response.data;
                self.isDataLoaded = true;
                self.lastUpdated = self.$moment().unix();

              } else {
                self.$f7.dialog.alert('Nepodarilo sa načítať aktuálnu hydrologickú situáciu', 'Nastala chyba');
              }

              self.$f7.dialog.close();
            }).catch((error) => {
          self.$f7.dialog.close();
          self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
        });
      }


    },
    checkLastUpdated() {
      if ((this.$moment().unix() - this.lastUpdated) > 5*60) { // ak posledne stiahnutie bolo pred vic ako 5 min, tak refresh
        this.pageReload(null, false);
      }
    },
    nl2br(str) {
      let breakTag = '<br />';
      return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
    }

  }

};
</script>

<style lang="scss">

.text-forecast-hs {
  ul {
    &:before {
      display: none;
    }
    .item-content {
      padding-left:0;
      .item-title {
        padding-left: calc(var(--f7-list-item-padding-horizontal) + var(--f7-safe-area-left));
      }
    }
    li.accordion-item-opened {
      .item-title {
        /* font-weight: bold; */
      }
    }

  }
  pre {
    overflow: auto;
    font-size: 10px;
  }
}


.s-c-header {
  justify-content: center;
  font-weight: bold;
  text-align: center;
}

.s-c-wrapper {
  .item-after {
    font-weight: bold;
    color: var(--f7-card-header-text-color);
  }
}


</style>
